(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/play-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/play-page.js');

'use strict';

const {
  useEffect,
  useState,
  useRef
} = React;
const {
  Betslip,
  MapPlay,
  Search,
  HomeButton,
  RightBottomButtons,
  PlayPageContainer,
  Params,
  SearchOverlay,
  Charity,
  Campaign
} = svs.lyckoplatsen.components.page_play.react.components;
const {
  useStorageWager
} = svs.lyckoplatsen.page_play.utils;
const {
  mapErrorDialog
} = svs.lyckoplatsen.shared_map.utils;
const jwt = svs.lyckoplatsen.data.config.jwt;
const {
  useResetPlayAtoms
} = svs.lyckoplatsen.components.page_play.react.hooks;
const {
  useAtomValue,
  useSetAtom
} = jotai;
const {
  newCustomerCampaignAtom,
  newCustomerCampaignPlayAtom,
  mapLocationAtom,
  pinLocationAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const PlayPage = () => {
  useStorageWager();
  const resetPlayAtoms = useResetPlayAtoms();
  const resetPlayAtomsRef = useRef(resetPlayAtoms);
  resetPlayAtomsRef.current = resetPlayAtoms;
  const campaign = useAtomValue(newCustomerCampaignAtom);
  const campaignPlay = useAtomValue(newCustomerCampaignPlayAtom);
  const setMapLocation = useSetAtom(mapLocationAtom);
  const pinLocation = useAtomValue(pinLocationAtom);
  const [isLoaded, setIsLoaded] = useState(false);
  const [campaignCoords, setCampaignCoords] = useState(null);
  const [applyLoadedClass, setApplyLoadedClass] = useState(false);
  const [isExternal, setIsExternal] = useState(false);
  useEffect(() => {
    if (!isExternal && applyLoadedClass) {
      var _svs$utils$paramHandl;
      const paramCoords = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
        key: 'coords'
      })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
      const [latitude, longitude] = (paramCoords === null || paramCoords === void 0 ? void 0 : paramCoords.split(',').map(Number)) || [];
      if (campaign.isActive) {
        resetPlayAtomsRef.current();
      }
      if (latitude && longitude && campaign.isActive) {
        setCampaignCoords({
          lat: latitude,
          lng: longitude
        });
      } else if (latitude && longitude && !campaign.hasCampaignIdParam) {
        resetPlayAtomsRef.current();
        setIsExternal(Boolean(paramCoords));
        setMapLocation({
          lat: latitude,
          lng: longitude,
          zoomLevel: CONSTANTS.FIRST_ZOOM_LEVEL,
          resetView: true,
          delay: 2,
          onStart: mapHandler => {
            mapHandler.placeStartClickCircle({
              lat: latitude,
              lng: longitude
            });
          }
        });
        svs.utils.paramHandler.remove({
          key: 'coords'
        });
      }
    }
  }, [applyLoadedClass, campaign.hasCampaignIdParam, campaign.isActive, isExternal, setMapLocation]);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 300);
    if (typeof jwt !== 'string' || jwt.length === 0) {
      mapErrorDialog();
    }
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (isLoaded) {
      const timer = setTimeout(() => setApplyLoadedClass(true), 30);
      return () => clearTimeout(timer);
    }
  }, [isLoaded]);
  let pageLoadedClass = '';
  if (applyLoadedClass) {
    pageLoadedClass = campaign.isActive ? 'page-loaded-from-start campaign' : 'page-loaded';
  }
  if (!isLoaded) {
    return null;
  }
  return React.createElement(PlayPageContainer, null, React.createElement(Params, null), React.createElement("div", {
    className: "lp-map-play-container relative ".concat(pageLoadedClass, " ").concat(campaignPlay ? 'play-campaign' : '')
  }, React.createElement("div", {
    className: "lp-map-play-top"
  }, React.createElement("div", {
    className: "animated-body"
  }, React.createElement(Search, null), React.createElement(HomeButton, null))), campaign.isActive && applyLoadedClass && !pinLocation && React.createElement(Campaign, {
    coords: campaignCoords
  }), isLoaded && React.createElement(MapPlay, {
    nodeId: "map-play"
  }), React.createElement(RightBottomButtons, null), React.createElement(Charity, null), React.createElement(Betslip, null)), React.createElement(SearchOverlay, null));
};
setGlobal('svs.lyckoplatsen.components.page_play.react', {
  PlayPage
});

 })(window);